import { useEffect } from 'react';
import { usePageContext } from 'vike-react/usePageContext';
import { setUser } from '@sentry/react';
import { applySentryReplaySamplingForSessionUser } from '../utils/sentry/sentry-replay-sampling';

/**
 * Hook to automatically set Sentry user context based on session
 */
export function useSentryUser() {
  const pageContext = usePageContext();
  const user = (pageContext as any)?.user;

  useEffect(() => {
    if (user?.id) {
      setUser({
        id: user.id,
        email: user.email,
        username: user.name || user.email,
      });
      void applySentryReplaySamplingForSessionUser(user);

      // Also set GA4 user properties
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('set', 'user_properties', {
          user_id: user.id,
          user_type: 'authenticated',
        });
      }
    } else {
      // Anonymous user
      setUser({
        id: undefined,
        username: 'anonymous',
      });
      void applySentryReplaySamplingForSessionUser(null);
    }
  }, [user?.id, user?.email]);
}

